import { useState } from "react";
import { createTransaction } from "./../../api/transactionApi";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import ToastService from "../../services/ToastService";

const AddMoney = () => {
  const navigate = useNavigate();

  const user = useSelector((state) => state.user.user);
  const [amount, setAmount] = useState(100000);
  const presetAmounts = [
    100000, 200000, 500000, 1000000, 2000000, 3000000,
  ];

  const formatCurrency = (value) => {
    return new Intl.NumberFormat("vi-VN").format(value);
  };
  const CreateTransaction = async () => {
    try {
      const data = await createTransaction({
        userId: user && user.guid,
        amount: amount,
      });
      
      ToastService.Success('Tạo mã thanh toán thành công!');
      window.open(data.payosOrderUrl, "_blank");
    } catch (error) {
      if (error.code === "ERR_NETWORK") {
        ToastService.Error(error.message);
        return;
      }
      console.log(error);
      ToastService.Error(error.response.data.message);
    }
  };
  return (
    <div className="flex items-center justify-center bg-[#14092e] text-white p-8  rounded-lg mb-4 background-wallet">
      {/* Card container - replacing Card component */}
      <div className="w-full max-w-3xl text-white ">
        {/* Card header - replacing CardHeader and CardTitle */}
        <div className="border-b border-[#4e3a8a]">
          <h2 className="text-xl font-bold ">NẠP TIỀN VÀO TÀI KHOẢN</h2>
        </div>

        {/* Card content - replacing CardContent */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Left column - Logo section */}
          <div className="flex flex-col items-center space-y-6">
            <p className="text-xl">Auto payment 247</p>

            {/* VietQR Logo */}
            <div className="w-full max-w-[250px]">
              <div className="text-5xl font-bold">
                <span className="text-[#e63946]">VIET</span>
                <span className="text-[#4361ee]">QR</span>
              </div>
            </div>

            {/* Napas Logo */}
            <div className="w-full max-w-[250px] mt-4">
              <div className="text-3xl font-bold text-[#4361ee]">
                napas
                <span className="text-[#4cd137]">✦</span>
              </div>
              <p className="text-sm mt-1">Một kết nối. Mọi thanh toán.</p>
            </div>
          </div>

          {/* Right column - Payment section */}
          <div className="flex flex-col space-y-6">
            <div>
              <p className="text-lg mb-2">Nhập số tiền:</p>
              <div className="grid grid-cols-3 gap-2">
                {presetAmounts.slice(0, 7).map((value) => (
                  <button
                    key={value}
                    className={`px-3 py-2 rounded-md text-sm font-medium transition-colors border border-dashed border-[#4e3a8a] ${
                      amount === value
                        ? "bg-[#4361ee] hover:bg-[#3a56d4] text-white"
                        : "bg-transparent hover:bg-[#2a1854] text-white"
                    }`}
                    onClick={() => setAmount(value)}
                  >
                    {formatCurrency(value)} đ
                  </button>
                ))}
              </div>
            </div>

            <div className="border border-[#4e3a8a] rounded-md p-4 flex justify-end items-center">
              <p className="text-2xl font-bold">
                {formatCurrency(amount)} <span className="">đ</span>
              </p>
            </div>

            <div className="space-y-4">
              <p className="font-medium">Quý khách lưu ý:</p>
              <ol className="list-decimal list-inside space-y-1 text-sm text-gray-300">
                <li>Số tiền tối thiểu 50.000 đ</li>
                <li>Số tiền tối đa 5.000.000 đ</li>
                 <li>
                  Tỷ lệ quy đổi: 
                  <br/>
                  100.000 = 100 coins
                  <br/>
                  500.000 = 500 coins
                  <br/>
                  3.000.000 = 3000 coins
                </li>
                <li>
                  Thanh toán sẽ tự động xác nhận trong khoảng 1 phút, nếu quá
                  thời hạn trên vui lòng liên hệ CSKH để được hỗ trợ.
                </li>
               
              </ol>

              <p className="text-sm ">
                Bằng chữ:{" "}
                <span className="text-white">{getAmountInWords(amount)}</span>
              </p>

              <button
                className="w-full py-6 mt-4 bg-[#0984e3] hover:bg-[#0876cc] text-white text-xl rounded-md font-medium transition-colors"
                onClick={async () => {
                  await CreateTransaction();
                }}
              >
                Tạo mã thanh toán
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddMoney;

// Helper function to convert amount to Vietnamese words
function getAmountInWords(amount) {
  if (amount === 200000) return "Hai trăm nghìn đồng.";

  // This is a simplified version - in a real app you'd implement full number-to-words conversion
  const units = [
    "",
    "một",
    "hai",
    "ba",
    "bốn",
    "năm",
    "sáu",
    "bảy",
    "tám",
    "chín",
  ];
  const thousands = ["", "nghìn", "triệu", "tỷ"];

  // Simple implementation for demo purposes
  if (amount === 50000) return "Năm mươi nghìn đồng.";
  if (amount === 100000) return "Một trăm nghìn đồng.";
  if (amount === 500000) return "Năm trăm nghìn đồng.";
  if (amount === 1000000) return "Một triệu đồng.";
  if (amount === 2000000) return "Hai triệu đồng.";
  if (amount === 5000000) return "Năm triệu đồng.";

  return "Năm mươi nghìn đồng.";
}
